import { useServiceCatalogUrl } from 'domain/shared/serviceCatalog';
import { useFieldHelper, LinkField, FieldProps } from 'framework/ui/field';

interface ServiceCatalogLinkProps extends FieldProps {
  nameSource: string;
}

const ServiceCatalogLink = ({ source, nameSource, ...props }: ServiceCatalogLinkProps) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getSingleEntityUrl } = useServiceCatalogUrl();
  const id = getValue();
  const name = getName();

  return <LinkField linkText={name || id} isInternal value={getSingleEntityUrl(id)} {...props} />;
};

export default ServiceCatalogLink;
